<template>
  <v-flex column>
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/complete-oauth-cover.jpg"
      height="150"
      role="img"
      aria-label="OAuth completion background"
    />

    <v-card color="primary">
      <v-layout
        pb-2
        color="primary"
      >
        <v-flex
          xs12
          sm12
          md12
          lg8
          offset-lg2
          justify-center
        >
          <v-card
            class="profile-section-card--flex-toolbar"
            flat
            color="primary"
          >
            <v-app-bar
              flat
              color="secondary"
            >
              <v-toolbar-title
                class="text-body-2"
                role="heading"
                aria-level="1"
              >
                {{ $t("components.oauthProfile.title") }}
              </v-toolbar-title>
            </v-app-bar>

            <v-stepper
              v-model="steps"
              alt-labels
            >
              <v-stepper-header>
                <v-stepper-step
                  :complete="steps > 0"
                  step="1"
                  aria-label="Step 1: Start"
                  role="columnheader"
                >
                  {{ $t("components.oauthProfile.subtitle") }}
                </v-stepper-step>

                <v-divider />

                <v-stepper-step
                  :complete="steps > 1"
                  step="2"
                  aria-label="Step 2: Verify Email"
                  role="columnheader"
                >
                  {{ $t("components.oauthProfile.steppers.verifyEmail") }}
                </v-stepper-step>

                <v-divider />

                <v-stepper-step
                  :complete="steps > 2"
                  step="3"
                  aria-label="Step 3: Setup Account"
                  role="columnheader"
                >
                  {{ $t("components.oauthProfile.steppers.setupAccount") }}
                </v-stepper-step>

                <v-divider />

                <v-stepper-step
                  :complete="steps > 3"
                  step="4"
                  aria-label="Step 4: Completed"
                  role="columnheader"
                >
                  {{ $t("components.oauthProfile.steppers.completed") }}
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items color="primary">
                <v-stepper-content step="2">
                  <v-card
                    class="mb-12"
                    height="200px"
                    aria-label="Verification step content"
                    role="none"
                  />

                  <v-btn
                    aria-label="Next step"
                    role="button"
                    color="accent"
                    @click="setStep(3)"
                  >
                    {{ $t("components.oauthProfile.buttons.next") }}
                  </v-btn>

                  <v-btn
                    aria-label="Cancel step"
                    role="button"
                    text
                  >
                    Cancel
                  </v-btn>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <CompleteOAuthProfileForm
                    aria-label="OAuth setup form"
                    role="form"
                    @complete-oauth="setStep(4)"
                  />
                </v-stepper-content>

                <v-stepper-content step="4">
                  <v-card flat>
                    <v-container
                      fluid
                      grid-list-md
                      role="none"
                      aria-label="Completed account overview"
                    >
                      <Overview
                        :username="username"
                        :email="email"
                        :zushin-points="zushinPoints"
                        :total-referred="totalReferred"
                        :total-referred-completed="totalReferredCompleted"
                        :referral-link="referralLink"
                      />
                    </v-container>
                  </v-card>

                  <v-btn
                    aria-label="Finish and go to profile"
                    role="link"
                    color="accent"
                    @click="redirectToProfile()"
                  >
                    {{ $t("components.oauthProfile.buttons.done") }}
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>

            <v-card flat />
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import links from "@/constants/links";
import CompleteOAuthProfileForm from "@/components/Views/CompleteOAuthProfileForm.vue";
import Overview from "@/components/Views/Overview.vue";
import { mapGetters } from "vuex";

export default {
    name: "CompleteOauthProfileLayout",
    components: {
        CompleteOAuthProfileForm,
        Overview
    },
    model: {
        event: "complete-oauth"
    },
    data() {
        return {
            steps: 3
        }
    },
    computed: mapGetters(["username", "email", "zushinPoints", "referralLink", "totalReferred", "totalReferredCompleted"]),
    watch: {
        username() {
            this.steps = 4;
        }
    },
    methods: {
        setStep(step) {
            this.steps = step;
        },
        redirectToProfile() {
            window.location.href = `${window.location.protocol}//${window.location.hostname}${links.routes.profileOverview}`;
        }
    }
};
</script>
